var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import styled from 'styled-components';
import Button from '@doordash/component-button';
import Loading from '@doordash/component-loading';
import ButtonGroup from '@doordash/component-button-group';
import { Stack, StackChildren, Text } from '@doordash/design-language';
import { QuickStartPageData } from '../EmOnboardingPageData';
import { BudgetForm, budgetFormValidationSchema, initialBudgetFormValues, } from './FormPartials/BudgetForm';
import { initialPaymentFormValues, PaymentForm, paymentFormValidationSchema, } from './FormPartials/PaymentForm';
import { usePaymentConfigQuery } from '../../../Billing/PaymentCard/usePaymentConfigQuery';
import { PaymentConfigProvider } from '../../../Billing/PaymentCard/PaymentComponents/PaymentConfigContext';
import { addCardTracking } from '../../../Billing/PaymentCard/Tracking/PaymentTracking';
import { getSelectedTeamAccountContent } from '../../../../selectors/uiSelector';
import { TEAM_ACCOUNT_COUNTRY_CODE } from '../../../../types/portal_data';
import { useTeamAccountConfigurationContext } from '../../../../components/TeamAccountPlanDetails/TeamAccountConfigurationContext';
import { getCurrencyByTeamAccountCountry } from '../../../../utils/currency';
import i18n from '../../../../i18n';
import track from '../../../../utils/track';
import { OnboardingEvents } from '../../../../constants/events';
var LoadingContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var QuickStartContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 800px;\n  width: 90%;\n"], ["\n  max-width: 800px;\n  width: 90%;\n"])));
var initialQuickStartFormValues = __assign(__assign({}, initialBudgetFormValues), initialPaymentFormValues);
export var QuickStartForm = function (_a) {
    var _b;
    var teamAccountId = _a.teamAccountId, hidePaymentMethod = _a.hidePaymentMethod, isProcessingForm = _a.isProcessingForm, handleFormSubmit = _a.handleFormSubmit, onBack = _a.onBack;
    // Payment Related
    var _c = usePaymentConfigQuery(teamAccountId), paymentConfig = _c.data, isPaymentConfigLoading = _c.loading;
    // Need to create a separate processing variable
    // because payment validation (thru VGS) is different from budget and whoWillPlaceOrder validation
    var _d = __read(React.useState(false), 2), isProcessingPayment = _d[0], setIsProcessingPayment = _d[1];
    // budget amount information
    var userLocale = i18n.getCurrentLocale();
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    var teamAccountCountryCode = (_b = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.countryCode) !== null && _b !== void 0 ? _b : TEAM_ACCOUNT_COUNTRY_CODE.US;
    var currencyCode = getCurrencyByTeamAccountCountry(teamAccountCountryCode);
    var _e = useTeamAccountConfigurationContext(), hasMaxBudgetAmountLimit = _e.hasMaxBudgetAmountLimit, maxBudgetAmountLimit = _e.maxBudgetAmountLimit;
    var initialFormValues = initialQuickStartFormValues;
    var validationSchema = yup.object().shape(__assign(__assign({}, budgetFormValidationSchema(hasMaxBudgetAmountLimit ? maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit : undefined)), (!hidePaymentMethod && paymentFormValidationSchema)));
    var valuesValidatedSubmitForm = function (values) {
        // When this method is called,
        // All validations are complete (BudgetForm, WhoWillPlaceFrom, PaymentForm)
        handleFormSubmit(values);
    };
    var isDependencyLoaded = function () {
        return !isPaymentConfigLoading;
    };
    return (React.createElement(React.Fragment, null, !isDependencyLoaded() ? (React.createElement(LoadingContainer, null,
        React.createElement(Loading, { size: Loading.Sizes.Medium }))) : (React.createElement(QuickStartContainer, null,
        React.createElement(StackChildren, { size: Stack.Sizes.Medium },
            React.createElement(Text, { styles: Text.Styles.PageTitle2 }, QuickStartPageData.title),
            React.createElement(Formik, { initialValues: initialFormValues, validationSchema: validationSchema, validateOnChange: false, validateOnBlur: false, onSubmit: valuesValidatedSubmitForm }, function (_a) {
                var errors = _a.errors, isSubmitting = _a.isSubmitting, values = _a.values, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
                return (React.createElement(Form, { noValidate: true },
                    React.createElement(StackChildren, { size: Stack.Sizes.XLarge },
                        React.createElement(BudgetForm, { maxBudgetAmountLimit: hasMaxBudgetAmountLimit
                                ? maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit : null, currenyCode: currencyCode, userLocale: userLocale, errors: errors, values: values, handleChange: handleChange }),
                        React.createElement(StackChildren, { size: Stack.Sizes.XxSmall },
                            React.createElement(Text, { styles: Text.Styles.FieldLargeLabel }, QuickStartPageData.membersSection.title),
                            React.createElement(Text, { styles: Text.Styles.FieldMediumInput, color: Text.Colors.FieldsForegroundPlaceholder }, QuickStartPageData.membersSection.description)),
                        !hidePaymentMethod && (React.createElement(PaymentConfigProvider, { value: paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.getPaymentConfigForTeamAccount },
                            React.createElement(PaymentForm, { submitting: isProcessingPayment, teamAccountId: teamAccountId, paymentCardTracking: addCardTracking, onSuccess: function () {
                                    handleChange('isPaymentMethodValid')('true');
                                    setIsProcessingPayment(false);
                                    handleSubmit(); // validate other fields
                                }, onFailure: function () {
                                    handleChange('isPaymentMethodValid')('false');
                                    setIsProcessingPayment(false);
                                    handleSubmit(); // validate other fields
                                } }))),
                        React.createElement(ButtonGroup, { insetSize: ButtonGroup.Spacing.None, primaryAction: {
                                content: QuickStartPageData.primaryCta,
                                onClick: function () {
                                    track(OnboardingEvents.QUICK_SETUP_SUBMIT);
                                    !hidePaymentMethod
                                        ? setIsProcessingPayment(true)
                                        : handleSubmit();
                                },
                                buttonProps: {
                                    state: isProcessingPayment ||
                                        isSubmitting ||
                                        isProcessingForm
                                        ? Button.States.Loading
                                        : Button.States.Default,
                                },
                            }, secondaryAction: {
                                content: QuickStartPageData.back,
                                onClick: onBack,
                            } }))));
            }))))));
};
var templateObject_1, templateObject_2;
